import { CartographerSource } from "@cartographerio/atlas-map";
import { internalError } from "@cartographerio/types";
import { raise } from "@cartographerio/util";
import {
  generatedMapCollaborationModel,
  generatedMapPermissionModel,
} from "./permissions.generated";

export function cartographerMapSourceWithDefaults(
  params: Omit<
    CartographerSource,
    "type" | "permissionModel" | "collaborationModel"
  >
): CartographerSource {
  const { layerId, ...rest } = params;
  return {
    type: "CartographerSource",
    layerId,
    permissionModel:
      generatedMapPermissionModel(layerId) ??
      raise(internalError("Unknown map source: " + layerId)),
    collaborationModel:
      generatedMapCollaborationModel(layerId) ??
      raise(internalError("Unknown map source: " + layerId)),
    ...rest,
  };
}
